import { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtMoney } from "@/lib/format";

export default function RiskUsagePanel() {
  const [usage, setUsage] = useState(null);

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const r = await api.get("/risk/usage");
        if (active) setUsage(r.data);
      } catch (e) { /* ignore */ }
    };
    load();
    const id = setInterval(load, 10000);
    return () => { active = false; clearInterval(id); };
  }, []);

  if (!usage) {
    return <div className="panel p-4 text-xs text-[#4B5563]">Loading risk telemetry…</div>;
  }

  const buyPct = Math.min(100, usage.daily_buy_pct);
  const posPct = (usage.open_positions / usage.max_open_positions) * 100;
  const buyClass = buyPct >= 90 ? "danger" : buyPct >= 60 ? "warn" : "";
  const posClass = posPct >= 90 ? "danger" : posPct >= 60 ? "warn" : "";

  return (
    <div className="panel" data-testid="risk-usage-panel">
      <div className="panel-header">
        <span>Risk Telemetry</span>
        <span className="text-[10px] font-mono text-[#4B5563]">{usage.trading_window}</span>
      </div>
      <div className="p-4 space-y-4">
        <Bar
          label="Daily Buy Cap"
          value={`${fmtMoney(usage.daily_buy_used)} / ${fmtMoney(usage.daily_buy_cap)}`}
          pct={buyPct}
          variant={buyClass}
          testId="risk-daily-buy"
        />
        <Bar
          label="Open Positions"
          value={`${usage.open_positions} / ${usage.max_open_positions}`}
          pct={posPct}
          variant={posClass}
          testId="risk-open-positions"
        />
        <div className="flex items-center justify-between text-xs pt-1 border-t border-[#272A30] pt-3">
          <span className="text-[10px] uppercase tracking-[0.2em] text-[#8B95A5]">Mode</span>
          <span className={`tag ${usage.execution_mode === "auto" ? "ai" : "hold"}`}>
            {usage.execution_mode}
          </span>
        </div>
        {usage.kill_switch_active && (
          <div className="text-[10px] uppercase tracking-[0.2em] font-mono text-[#FF3B30] border border-[#FF3B30] p-2 text-center">
            ● Kill Switch Active — All Automation Halted
          </div>
        )}
      </div>
    </div>
  );
}

function Bar({ label, value, pct, variant, testId }) {
  return (
    <div data-testid={testId}>
      <div className="flex items-center justify-between text-[10px] uppercase tracking-[0.2em] mb-1">
        <span className="text-[#8B95A5]">{label}</span>
        <span className="font-mono text-white">{value}</span>
      </div>
      <div className={`risk-bar ${variant}`}>
        <span style={{ width: `${Math.max(2, pct)}%` }} />
      </div>
    </div>
  );
}
